/** Designer / boutique / luxury / local-shops browse carousel chips */
export const DESIGNER_BROWSE_CATEGORIES = [
  { name: 'Bags', icon: '👜', value: 'Bags' },
  { name: 'Accessories', icon: '🕶️', value: 'Accessories' },
  { name: 'Vintage Collections', icon: '📦', value: 'Vintage Collections' },
  { name: 'Tableware', icon: '🍽️', value: 'Tableware' },
  { name: 'Jewelry', icon: '💍', value: 'Jewelry' },
  { name: 'Fashion', icon: '👗', value: 'Fashion' },
  { name: 'Home Decor', icon: '🏠', value: 'Home Decor' },
  { name: 'Art & Paintings', icon: '🎨', value: 'Art & Paintings' },
  { name: 'Nails', icon: '💅', value: 'Nails' },
];
